import React, {useEffect, useState} from 'react';
import images from '../images';
import {useAuth} from '../context/AuthContext';
import LoginForm from '../components/Forms/LoginForm';
import LogoBlock from '../components/LogoBlock';
import {useNavigate} from 'react-router-dom';

const Login = () => {
  const { login: loginMethod } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [termsCheck, setTermsCheck] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError('Пожалуйста, введите логин и пароль');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Вызываем метод авторизации
      const success = await loginMethod(email, password);

      // Сохраняем данные пользователя в сессию (в реальности можно использовать localStorage)
      // Для заглушки просто передаем дальше
      if (success) {
        navigate('/');
      }
      // Перенаправляем на главную страницу после успешного входа
    } catch (err) {
      // Ошибка уже будет показана в Toast через apiRequest
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-content">
          <LogoBlock />
          <LoginForm
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            loading={loading}
            error={error}
            handleSubmit={handleSubmit}
            termsCheck={termsCheck}
            setTermsCheck={setTermsCheck}
          />
          <div className="login-footer">
            <p>Ещё не заключили договор? <a href="https://partner-leeds.ru/" className="login-link">Свяжитесь с нами, оставив заявку на сайте</a></p>
          </div>
        </div>
        </div>
        <div
            className="login-right"
          style={{backgroundImage: `url(${images.loginBackground})` }}
      ></div>
    </div>
  );
};

export default Login;